<template>
	<div
		id="docType-detail"
		:class="[!isWeb ? 'mobile-docType-detail' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="detail-title">
			<div class="detail-title__icon" @click="goToDocTypes()">
				<SidebarArrow :border="'#0047ff'" />
			</div>
			<h1 class="detail-title__text">
				{{ !$route.query.id ? 'Adicionar Tipo de Documento' : 'Editar Tipo de Documento' }}
			</h1>
		</div>
		<DocTypeForm :isWeb="isWeb" />
	</div>
</template>

<script>
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import DocTypeForm from '@/components/modules/DocType/DocTypeDetail/DocTypeForm/DocTypeForm.vue';

export default {
	name: 'DocTypeDetail',
	components: { SidebarArrow, DocTypeForm },
	data: () => ({
		windowWidth: window.innerWidth,
	}),
	created() {},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		goToDocTypes() {
			this.$router.push({ path: '/dashboard/config/docType' });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'DocTypeDetail.scss';
</style>
